/**
 * Father's Day countdown timer — self-initialising, no dependencies.
 * Targets every .so-countdown[data-target] element on the page.
 */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function updateUnit(el, cls, val) {
    var num = el.querySelector(cls);
    if (!num) return;
    var next = pad(val);
    if (num.textContent !== next) {
      num.classList.remove('so-countdown__flip');
      void num.offsetWidth; // reflow
      num.classList.add('so-countdown__flip');
      num.textContent = next;
    }
  }

  function tick(el) {
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;
    var diff = target - Date.now();

    if (diff <= 0) {
      var expired = el.dataset.expired || "Happy Father's Day! 🎉";
      el.innerHTML =
        '<span class="so-countdown__expired">' +
        '<svg class="so-countdown__fd-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>' +
        '</svg>' + expired + '</span>';
      return;
    }

    updateUnit(el, '.so-countdown__days',  Math.floor(diff / 86400000));
    updateUnit(el, '.so-countdown__hours', Math.floor((diff % 86400000) / 3600000));
    updateUnit(el, '.so-countdown__mins',  Math.floor((diff % 3600000) / 60000));
    updateUnit(el, '.so-countdown__secs',  Math.floor((diff % 60000) / 1000));
  }

  function init() {
    var countdowns = document.querySelectorAll('.so-countdown');
    if (!countdowns.length) return;
    countdowns.forEach(function (el) { tick(el); });
    setInterval(function () { countdowns.forEach(tick); }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
